import React from 'react';
import { motion as fmMotion } from 'framer-motion';

/**
 * Drop-in replacement for framer-motion's `motion` that neutralizes entrance
 * animations on phones: every element renders directly in its settled state
 * (`initial={false}`), so nothing waits hidden for a scroll trigger or a
 * mount animation. Desktop passes through untouched, and controlled
 * animations (swaps, toggles) keep working on both — they're driven by
 * `animate`, which is preserved.
 */

// Kill-switch currently OFF — phones get the full animation set. Flip this
// back to a width check to make phones render everything statically again.
const isPhone = () => false;

const cache = new Map();

export const motion = new Proxy(fmMotion, {
  get(target, key) {
    const Base = target[key];
    if (typeof Base !== 'object' && typeof Base !== 'function') return Base;
    if (!cache.has(key)) {
      const Wrapped = React.forwardRef((props, ref) =>
        isPhone()
          ? React.createElement(Base, { ref, ...props, initial: false })
          : React.createElement(Base, { ref, ...props })
      );
      Wrapped.displayName = `motionShim.${String(key)}`;
      cache.set(key, Wrapped);
    }
    return cache.get(key);
  },
});
